
import  React ,{ useState }from 'react';
import './App.css';
import { Grid, Modal , Box, Typography, Icon, Card, TextField, Button, Checkbox, useMediaQuery } from "@mui/material";
import { ThemeProvider , createTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PhoneInput from './components/PhoneInput';
import axios from 'axios';

const theme = createTheme({
  palette: {
    primary: {
      main: '#AA2617',
    },
    secondary: {
      main: '#D78A04',
    },
  },
  typography: {
    fontFamily: "Quicksand"
  }
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '55%',
  bgcolor: 'background.paper',
  border: '1px solid white',
  boxShadow: 24,
  p: 3,
};

function App() {

  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [isFisica, setIsFisica] = useState(true);
  const [open , setOpen]= useState(false);
  const [ validation , setValidation]= useState(false);
  const matches = useMediaQuery('(max-width:850px)');

  const validationSchema = Yup.object({
    name: Yup.string().required('Requerido'),
    email: Yup.string().email("Formato inválido").required('Requerido'),
    state: Yup.string().required('Requerido'),
})

  const formik = useFormik({
    initialValues: {
        name: '',
        email: '',
        phone: '',
        state: '',
        company: '',
    },
    onSubmit: async (values) => {
      if(checked1 && checked2){
        setOpen(true);
        sendEmails(values); 
      }
    },
    isInitialValid: false,
    validationSchema,
    validate: values => {
      
      let errors = {}
      if(!values.phone) {
        errors.phone = "Requerido"
      } else if(values.phone.toString().length !== 10) {
          errors.phone = "El teléfono debe tener 10 caracteres"
      }

      if(isFisica===false && values.company===''){
        errors.company = "Requerido"
      }

      return errors
    }
  })


  const handleChange1 = (event) => {
    setChecked1(event.target.checked);
    if(event.target.checked && checked2){
      setValidation(true)
    }else{
      setValidation(false)
    }
  };

  const handleChange2 = (event) => {
    setChecked2(event.target.checked);
    if(event.target.checked && checked1){
      setValidation(true)
    }else{
      setValidation(false)
    }
    
  };

  const onClickMoral =()=>{
    setIsFisica(false)
  }

  const onClickFisica =()=>{
    setIsFisica(true)
  }


  const handleClose = () => {
    setOpen(false);
    window.open("https://siavial.com/proveedor/", "_self")
};

  /* Llamadas a la API */
  const sendEmails=async(values)=>{
    let emailProvider ={
      "email": values.email,
      "nombre": values.name,
    }

    let emailSiavial ={
      "email": values.email,
      "nombre": values.name,
      "telefono": values.phone,
      "empresa": values.company,
    }

    try {
      await axios.post(`https://api.siavial.com/v1.0/proveedor/email/preregistro`,emailProvider);
      await axios.post(`https://api.siavial.com/v1.0/proveedor/email/preregistro/siavial`,emailSiavial);
    } catch (error) {
      console.error(error);
    }
  }

  const openCondiciones = () => {
    window.open('https://assets-siavial.s3.amazonaws.com/landing/terminos-condiciones.pdf', '_blank');
}

const openAviso = () => {
    window.open('https://assets-siavial.s3.amazonaws.com/landing/aviso-privacidad.pdf', '_blank');
}

  return (
    <>
    <ThemeProvider theme={theme}>

    {/* Banda roja de fondo */}
    <Grid container className= 'liston'>
        <Grid item xs={matches ? 12:6}>
          <Typography className='liston-text'>
              Después de compartirnos tu información de contacto , uno de nuestros asesores se 
              podrá en contacto contigo para finalizar el proceso de reclutamiento y ser parte de  nuestra 
              familia de proveedores.
            </Typography>
        </Grid>
        <Grid item xs={6}></Grid>
    </Grid>

    {/* Opcion de back */}
    <Grid style={{display:'flex' , alignItems:'center' , zIndex:3 , padding: '10px'}}>
        <Icon className="fas fa-chevron-left icon-style" /> 
        <Typography style={{cursor: 'pointer'}} onClick={()=>window.open("https://siavial.com/proveedor/", "_self")}>Regresar</Typography>
    </Grid>
    
      <Grid container style={{padding: matches ? 10:40}}>

        {/* Logo y texto superior */}
        <Grid item xs={matches? 12:6}  >
          <Grid container>
            <Grid item xs={matches ? 4:3}>
              <img alt="" 
                width = {matches ? "80":"100" } 
                hight = {matches ? "80":"100" } 
                src={"https://assets-siavial.s3.amazonaws.com/general/logo.png"}>
              </img>
            </Grid>
            <Grid item xs={matches ? 8:9} style={{paddingTop: matches ? '5px':'40px'}}>
              <Typography variant="label">esta muy cerca de ser un</Typography>
              <Typography variant="h4"><b>Proveedor SIAVIAL</b></Typography>
            </Grid>
          </Grid>

          {
            !matches ? (
              <>
                <Grid className='wrap'>
                  <Typography variant="label" className='wrap-span'>Llegamos a más personas que necesitan una...</Typography>
                </Grid>
                <Grid >
                  <Typography variant="h4" className='wrap-span'><b>asistencia vial</b></Typography>
                </Grid>
              </>
            ):null
          }
        </Grid>
        
        {/* Formulario */}
        
        <Grid item xs={matches? 12:6} mt={matches ? 20:1}>
        <form onSubmit={formik.handleSubmit}>
            <Card className='form-container'>
              <Typography align='center' variant="h5"><b>Cuéntanos un poco sobre ti …</b></Typography>
              <TextField
                name="name" 
                label="Mi nombre" 
                variant="outlined" 
                value={formik.values.name} 
                onChange={formik.handleChange} 
                onBlur={formik.handleBlur}
                error={formik.touched.name && formik.errors.name ? true : false} 
                helperText={formik.touched.name && formik.errors.name ? formik.errors.name : ''}
                style={{marginTop: '25px'}} 
                fullWidth
              />
              <TextField
                name="email"  
                label="Correo electrónico" 
                variant="outlined" 
                value={formik.values.email} 
                onChange={formik.handleChange} 
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email ? true : false} 
                helperText={formik.touched.email && formik.errors.email ? formik.errors.email : ''}
                style={{marginTop: '25px'}} 
                fullWidth
              />
              <Grid container style={{marginTop: '0px'}} spacing={3}>
                <Grid item xs={matches ? 12:6}>
                    <TextField 
                      name="phone"  
                      label="Número de teléfono" 
                      variant="outlined" 
                      value={formik.values.phone} 
                      onChange={formik.handleChange} 
                      onBlur={formik.handleBlur}
                      error={formik.touched.phone && formik.errors.phone ? true : false}  
                      helperText={formik.touched.phone && formik.errors.phone ? formik.errors.phone : ''}
                      fullWidth
                      InputProps={{ inputComponent: PhoneInput }}
                    />
                </Grid>
                <Grid item xs={matches ? 12:6}>
                    <TextField 
                      name="state"
                      label="Estado" 
                      variant="outlined" 
                      value={formik.values.state} 
                      onChange={formik.handleChange} 
                      onBlur={formik.handleBlur}
                      error={formik.touched.state && formik.errors.state ? true : false}  
                      helperText={formik.touched.state && formik.errors.state ? formik.errors.state : ''} 
                      fullWidth/>
                </Grid>
              </Grid>
              {/* Grid para botones de persona Moral / Fisica */}
              <Grid container style={{ display:'flex' , alignItems:'center' , marginTop: '0px'}} spacing={3}>
                <Grid item xs={matches ? 12:6}>
                    <Typography>Trabajo cómo persona  </Typography>
                </Grid>
                <Grid item xs={matches ? 6:3}>
                    <Button className={isFisica? 'button-select':'button-normal'} fullWidth onClick={onClickFisica}>Fisica</Button>
                </Grid>
                <Grid item xs={matches ? 6:3}>
                    <Button className={isFisica? 'button-normal':'button-select'} fullWidth onClick={onClickMoral}>Moral</Button>
                </Grid>
                {
                  !isFisica && (
                    <Grid item xs={12}>
                      <TextField 
                        name="company"
                        label="Nombre de la empresa" 
                        variant="outlined" 
                        value={formik.values.company} 
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur}
                        error={formik.touched.company && formik.errors.company ? true : false}  
                        helperText={formik.touched.company && formik.errors.company ? formik.errors.company : ''} 
                        fullWidth/>
                    </Grid>
                  )
                }
              </Grid>

              {/* Checks para aceptar terminos y condiciones */}
              <Grid style={{display:'flex' , alignItems:'center'}} mt={4}>
                <Checkbox checked={checked1} onChange={handleChange1}/>
                <Typography>Acepto las  <span style={{ cursor:"pointer"}} onClick={()=>openCondiciones()}> <b>condiciones generales.</b></span></Typography>
              </Grid>
              <Grid style={{display:'flex' , alignItems:'center'}}>
                <Checkbox checked={checked2} onChange={handleChange2}/>
                <Typography>Acepto el <span style={{ cursor:"pointer"}} onClick={()=>openAviso()}><b>aviso de privacidad.</b></span></Typography>
              </Grid>
              <Grid container justify="center" mt={4}>
                  <Button 
                    type="submit"
                    style={{margin: '0 auto', display: "flex"}} 
                    className={validation ? 'button-submit':'button-normal'} 
                    disabled={!validation}
                  >Quiero ser proveedor</Button>
              </Grid>
            </Card>
            </form>
        </Grid>
         {/* FIN Formulario */}
        

      </Grid>

      {/* Modal submit */}
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Box sx={style}>
          <Typography variant={matches ? "label":"h6"}  align='center'>
            Estamos muy contentos !
          </Typography>
          <Typography variant={matches ? "h6":"h4"}  align='center' color='primary'>
            <b>Provedor SIAVIAL</b>
          </Typography>
          <Typography  sx={{ mt: 2 , fontSize: matches ?'10px':'14px'}} align='center'>
            En un lapso <b>no mayor a 24 horas</b> uno de nuestros 
            agentes se pondrá en contacto contigo para finalizar 
            tu ingreso a nuestra familia de proveedores. 
          </Typography>
          <Grid container justify="center" mt={4}>
              <Button style={{margin: '0 auto', display: "flex"}} className='button-submit' onClick={handleClose}>De acuerdo</Button>
          </Grid>
        </Box>
      </Modal>

      </ThemeProvider>
    </>
  );
}

export default App;
